<template>
    <div class="container-fluid reports-container weeducAdminReports weeduc-admin-page page-card text-start p-0">
        <header class="weeduc-admin-page__header">
            <div class="weeduc-admin-page__header-lead">
                <TitlePage
                    title="Relatórios"
                    subtitle="Navegue pelas abas, consulte os dados e exporte em CSV quando disponível."
                    :hasMargin="false"
                />
            </div>
            <div class="weeduc-admin-page__header-actions">
                <v-btn
                    variant="flat"
                    color="primary"
                    rounded="lg"
                    title="Exportar dados em CSV"
                    :icon="$vuetify.display.xs"
                    class="text-none edit-courses-new-btn"
                    @click="exportToCSV"
                >
                    <template v-if="$vuetify.display.xs">
                        <v-icon>mdi-file-export</v-icon>
                    </template>
                    <template v-else>
                        <v-icon class="me-1" size="small">mdi-file-export</v-icon>
                        Exportar CSV
                    </template>
                </v-btn>
            </div>
        </header>

        <div class="weeduc-admin-page__shell">
            <div class="weeduc-admin-page__panel weeduc-admin-page__panel--reports">
                <div class="weeduc-admin-reports__tabs-header">
                    <div class="weeduc-admin-reports__tabs-scroll" role="tablist" aria-label="Tipos de relatório">
                        <button
                            v-for="tab in reportTabs"
                            :key="tab.id"
                            type="button"
                            role="tab"
                            :aria-selected="activeTab === tab.id"
                            class="weeduc-admin-reports__tab"
                            :class="{ active: activeTab === tab.id }"
                            @click="activeTab = tab.id"
                        >
                            {{ tab.label }}
                        </button>
                    </div>
                </div>

                <div class="weeduc-admin-reports__heading">
                    <h3 class="weeduc-admin-reports__heading-title">{{ currentReportTitle }}</h3>
                    <p class="weeduc-admin-reports__heading-lead">{{ currentReportSubtitle }}</p>
                </div>

                <div v-if="activeTab === 'vendas'" class="weeduc-admin-reports__tab-content">
                    <ReportSales ref="reportSales" :searchTerm="searchTerm" />
                </div>
                <div v-if="activeTab === 'matriculas'" class="weeduc-admin-reports__tab-content">
                    <ReportCourses ref="reportCourses" :searchTerm="searchTerm" :courseName="courseName"/>
                </div>
                <div v-if="activeTab === 'duvidas'" class="weeduc-admin-reports__tab-content">
                    <ReportDoubts ref="reportDoubts" />
                </div>
                <div v-if="activeTab === 'forum'" class="weeduc-admin-reports__tab-content">
                    <ReportForum ref="reportForum" :searchTerm="searchTerm" />
                </div>
                <div v-if="activeTab === 'quizes'" class="weeduc-admin-reports__tab-content">
                    <ReportQuizes ref="reportQuizes" />
                </div>
                <div v-if="activeTab === 'avisos'" class="weeduc-admin-reports__tab-content">
                    <ReportWarnings ref="reportWarnings"/>
                </div>
                <div v-if="activeTab === 'usuarios'" class="weeduc-admin-reports__tab-content">
                    <ReportUsers ref="reportUsers"/>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { mapState } from 'vuex';

import Loader from '@/components/Loader/loader.vue';
import TitlePage from '@/components/Weflix/titlePage.vue';
import ReportEnrols from '@/components/Admin/Reports/courses.vue';
import ReportForum from '@/components/Admin/Reports/forum.vue';
import ReportUsers from '@/components/Admin/Reports/users.vue';
import ReportSales from '@/components/Admin/Reports/enrols.vue';
import ReportWarnings from '@/components/Admin/Reports/warnings.vue';
import ReportDoubts from '@/components/Admin/Reports/doubts.vue';
import ReportCourses from '@/components/Admin/Reports/courses.vue';
import ReportQuizes from '@/components/Admin/Reports/quizes.vue';

// Import Vuetify VSelect if not globally registered
// import { VSelect } from 'vuetify/lib';

export default {
    // If using local registration:
    // components: {
    //     Loader,
    //     ReportEnrols,
    //     ReportForum,
    //     ReportUsers,
    //     ReportSales,
    //     ReportWarnings,
    //     ReportDoubts,
    //     ReportCourses,
    //     VSelect
    // },
    components: {
        Loader,
        TitlePage,
        ReportEnrols,
        ReportForum,
        ReportUsers,
        ReportSales,
        ReportWarnings,
        ReportDoubts,
        ReportCourses,
        ReportQuizes
    }, 
    data() {
        return {
            label: this.labels,
            reportsFiltered: [],
            searchTerm: '',
            currentPage: 1,
            itemsPerPage: 5,
            alertOpenReport:false,
            removedReportName:'',
            afterWidth:40,
            reportsData:[],
            openModalCreateReport:false,
            openModalEditReport:false,
            id:'',
            message:'',
            title:'',
            hasReady: false,
            searchText: '',
            activeTab: 'vendas',
            courseName: null,
        };
    },
    computed:{
        ...mapState(["token","numberIntensTable"]),

        reportTabs() {
            return [
                { id: 'vendas', label: 'Vendas' },
                { id: 'matriculas', label: 'Matrículas' },
                { id: 'duvidas', label: 'Dúvidas' },
                { id: 'forum', label: 'Fórum' },
                { id: 'quizes', label: 'Questionários' },
                { id: 'avisos', label: 'Avisos' },
                { id: 'usuarios', label: 'Usuários' },
            ];
        },

        reportTabMeta() {
            return {
                vendas: {
                    section: 'Vendas',
                    subtitle: 'Pedidos, valores totais e forma de pagamento — use os filtros e exporte em CSV quando precisar.',
                },
                matriculas: {
                    section: 'Matrículas',
                    subtitle: 'Matrículas por curso e aluno; refine com os campos de filtro.',
                },
                duvidas: {
                    section: 'Dúvidas',
                    subtitle: 'Dúvidas registradas pelos alunos nas aulas.',
                },
                forum: {
                    section: 'Fórum',
                    subtitle: 'Participação e tópicos do fórum do seu ambiente.',
                },
                quizes: {
                    section: 'Questionários',
                    subtitle: 'Notas e tentativas dos questionários vinculados aos cursos.',
                },
                avisos: {
                    section: 'Avisos',
                    subtitle: 'Histórico de avisos enviados aos alunos.',
                },
                usuarios: {
                    section: 'Usuários',
                    subtitle: 'Cadastro e dados dos usuários com acesso à plataforma.',
                },
            };
        },

        currentReportTitle() {
            const m = this.reportTabMeta[this.activeTab];
            return m ? `Relatórios de ${m.section}` : 'Relatórios';
        },

        currentReportSubtitle() {
            const m = this.reportTabMeta[this.activeTab];
            return m ? m.subtitle : '';
        },

        paginatedReports() {
            const startIndex = (this.currentPage - 1) * this.numberIntensTable;
            const endIndex = startIndex + this.numberIntensTable;
            return this.filteredReports.slice(startIndex, endIndex);
        },
        totalPages() {
            return Math.ceil(this.filteredReports.length / this.numberIntensTable);
        },
        filteredReports() {
            let filtered = this.reportsData;

            if (this.searchText && this.searchText.trim() !== '') {
                filtered = filtered.filter((report) =>
                    report.title.toLowerCase().includes(this.searchText.toLowerCase())
                );
            }

            return filtered;
        }
    },
    methods: {
        filtrarReports() {
            this.currentPage = 1;
        },
        previousPage() {
            if (this.currentPage > 1) {
                this.currentPage--;
            }
        },
        nextPage() {
            if (this.currentPage < this.totalPages) {
                this.currentPage++;
            }
        },
        removeReport(id, name){
            this.removedReportName = name;
            this.alertOpenReport = !this.alertOpenReport;
            setTimeout(() => {
                this.alertOpenReport = !this.alertOpenReport;
                this.removedReportName = '';
            }, 4000);
        },
        editReport(id, title, description, status){
            this.openModalEditReport = !this.openModalEditReport;
            this.id = id;
            this.title = title;
            this.message = description;
            this.status = status;
        },
        createReport(){
            this.openModalCreateReport = !this.openModalCreateReport;
        },
        updateValueCreate(newValue){
            this.openModalCreateReport = newValue;
            this.getDataReport();
        },
        updateValueEdit(newValue){
            this.getDataReport();

            this.openModalEditReport = newValue;
        },

        // exportoToCSV () {
        //     this.$refs.reportSales.exportToCSV();
        // },
        // testCSV() {
        //     this.$refs.reportSales.testSonCSV();
        // },
        onSearchInput() {
            console.log('Search term updated:', this.searchTerm);
        },
        onClickSearchReport() {
            console.log('Search term in parent:', this.searchTerm);
            console.log('Active tab:', this.activeTab);
            
            // Verifica qual aba está ativa e chama a função apropriada
            if (this.activeTab === 'vendas' && this.$refs.reportSales) {
                console.log('Calling reportSales with search term:', this.searchTerm);
                this.$refs.reportSales.getDataReport(this.searchTerm);
            } else if (this.activeTab === 'matriculas' && this.$refs.reportCourses) {
                console.log('Calling reportCourses with search term:', this.searchTerm);
                this.$refs.reportCourses.getDataReport(this.searchTerm);
            }
        },
        exportToCSV() {
            const exportMap = {
                "vendas": "reportSales",
                "matriculas": "reportCourses",
                "duvidas": "reportDoubts",
                "forum": "reportForum",
                "quizes": "reportQuizes",
                "avisos": "reportWarnings",
                "usuarios": "reportUsers",
            };

            const refName = exportMap[this.activeTab];
            
            if (refName && this.$refs[refName]) {
                this.$refs[refName].exportToCSV();
            }
        },
        processUrlParams() {
            const query = this.$route.query;
            
            console.log('Parâmetros da URL:', query);
            
            // Verificar se há filtro de matrículas
            if (query.filter === 'matriculas') {
                this.activeTab = 'matriculas';
                console.log('Aba ativa definida como matrículas');
            }
            
            // Verificar se há nome do curso e decodificar
            if (query.courseName) {
                // Decodificar o nome do curso da URL (pode vir codificado)
                this.courseName = decodeURIComponent(query.courseName);
                console.log('Nome do curso capturado:', this.courseName);
                
                // Aguardar o próximo tick para garantir que o componente filho esteja renderizado
                this.$nextTick(() => {
                    if (this.$refs.reportCourses) {
                        // Forçar atualização do componente filho
                        this.$refs.reportCourses.getDataReport();
                    }
                });
            }
        },
    },
    watch: {
        activeTab(newTab) {
            // Quando a aba mudar para matrículas e houver courseName, atualizar o componente filho
            if (newTab === 'matriculas' && this.courseName) {
                this.$nextTick(() => {
                    if (this.$refs.reportCourses) {
                        this.$refs.reportCourses.getDataReport();
                    }
                });
            }
        }
    },
    mounted() {
        // Processar parâmetros da URL
        this.processUrlParams();
    }
};
</script>

<style scoped>
@import url('@/css/weeduc/admin/dashboard-weflix-shell.css');

/* (mantém o CSS original, pois o Vuetify sobrescreve o select) */
.container.reports-container {
    padding: 1.5rem;
    width: 100%;
}

.weeduc-admin-reports {
    padding: 4px 0 8px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 2rem;
}

.weeduc-admin-reports .search-input {
    width: 400px;
    max-width: 100%;
    border: 1px solid #ccc;
    outline: none;
    font-size: 14px; 
    padding: 0.5rem; 
    color: #333;
    border-radius: 8px;
    margin-right: 8px;
}

.weeduc-admin-reports .btn-search {
    background: transparent; 
    border: none; 
    cursor: pointer; 
    padding: 0.5rem; 
    display: flex; 
    align-items: center; 
    justify-content: center; 
    color: #555; 
}

.weeduc-admin-reports .btn-search:hover {
    color: #000; 
}

.weeduc-admin-reports .btn-weflix {
    background-color: #2f2e8b;
    color: white;
    padding: 0.5rem 1rem;
    border-radius: 6px;
    cursor: pointer;
    display: flex;
    align-items: center;
    gap: 0.5rem;
    font-weight: 600;
    transition: all 0.3s ease;
    box-shadow: 0 2px 4px rgba(47, 46, 139, 0.2);
}

.weeduc-admin-reports .btn-weflix:hover {
    background-color: #23225f;
    transform: translateY(-2px);
    box-shadow: 0 4px 8px rgba(47, 46, 139, 0.3);
}

.weeduc-admin-reports .btn-weflix svg {
    color: white;
}

.weeduc-admin-reports .btn-search:hover {
    color: #000; 
}

.weeduc-admin-reports .form-control:focus {
    box-shadow: none;
}

.title-container {
    position: relative;
    margin-bottom: 10px;
    padding-bottom: 0;
    text-align: left;
}

.title-container .title {
    font-size: 1.5rem;
    font-weight: 400;
    color: #000000;
    margin: 0 0 0.5rem;
}

.cupons-table-responsive {
    background-color: #ffffff;
    border-radius: 8px;
    overflow: hidden;
    margin-bottom: 1rem;
}

.cupons-table {
    width: 100%;
    border-collapse: separate;
    border-spacing: 0;
}

.cupons-table th {
    background-color: #f8fafc;
    padding: 0.75rem;
    font-weight: 600;
    color: #4a5568;
    text-align: left;
    border-bottom: 2px solid #e2e8f0;
}

.cupons-table td {
    padding: 0.75rem;
    vertical-align: middle;
    border-bottom: 1px solid #f0f0f0;
    color: #4a5568;
}

.cupons-table tr:hover {
    background-color: #f8fafc;
}

.badge-active, .badge-inactive {
    padding: 0.25rem 0.75rem;
    border-radius: 5px;
    font-size: 0.75rem;
    font-weight: 500;
    display: inline-block;
    text-align: center;
    transition: all 0.2s ease;
    width: 70%;
}

.badge-active {
    background-color: #7bcc8180;
    color: #4b614e;
}

.badge-inactive {
  background-color: #d7d7ee80;
    color: #2f2e8b;
    }

.cupom-btn-edit {
    padding: 0.4rem;
    margin: 0 0.25rem;
    border: none;
    border-radius: 6px;
    cursor: pointer;
    transition: all 0.2s ease;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    width: 32px;
    height: 32px;
   color: #2f2e8b;
}

.search-form-control {
    width: 100%;
    padding: 0.5rem 0.75rem;
    border: 1px solid #e2e8f0;
    border-radius: 6px;
    font-size: 0.875rem;
    transition: all 0.2s ease;
}

.search-form-control:focus {
    outline: none;
    border-color: #2f2e8b;
    box-shadow: 0 0 0 3px rgba(47, 46, 139, 0.1);
}

.cupons-pagination {
    display: flex;
    justify-content: center;
    align-items: center;
    gap: 1rem;
    margin-top: 1rem;
}

.cupons-page-btn {
    padding: 0.5rem 1rem;
    border: 1px solid #e2e8f0;
    border-radius: 6px;
    background: white;
    color: #4a5568;
    cursor: pointer;
    transition: all 0.2s;
}

.cupons-page-btn:disabled {
    opacity: 0.5;
    cursor: not-allowed;
}

.cupons-page-btn:not(:disabled):hover {
    background: #f8fafc;
    border-color: #cbd5e0;
}

.cupons-page-info {
    color: #4a5568;
    font-size: 0.875rem;
}

@media (max-width: 968px) {
    .weeduc-admin-reports {
        flex-direction: column;
        align-items: flex-start;
        gap: .75rem;
    }

    .weeduc-admin-reports .filter-wrapper {
        width: 100%;
    }
}

@media (max-width: 768px) {

    .title-container {
        margin-bottom: 1.5rem;
    }

    .cupons-table th, .cupons-table td {
        padding: 0.5rem;
    }

    .weeduc-admin-reports .btn-weflix {
        padding: 8px;
    }
}

@media (max-width: 600px) {
    .container.reports-container {
        padding: 1rem;
    }

    .badge-active, .badge-inactive {
        padding: 5px 5px !important;
        border-radius: 5px;
        font-size: 0.75rem;
        font-weight: 500;
        display: inline-block;
        text-align: center;
        transition: all 0.2s ease;
        width: 100% !important;
    }
}

select.form-control.filter-form-control {
    width: 60%;
}

table.table.cupons-table {
    border: none !important;
    padding: 0 !important;
}
button.btn-edit.cupom-btn-edit svg {
    color: #2f2e8b;
}

.export-button-top {
    display: flex;
    align-items: center;
    flex-shrink: 0;
}

.export-button-top .btn-weflix {
    background-color: #2f2e8b;
    color: white;
    padding: 0.75rem 1.5rem;
    border-radius: 6px;
    cursor: pointer;
    display: flex;
    align-items: center;
    gap: 0.5rem;
    font-weight: 600;
    transition: all 0.3s ease;
    box-shadow: 0 2px 4px rgba(47, 46, 139, 0.2);
    border: none;
    white-space: nowrap;
}

.export-button-top .btn-weflix:hover {
    background-color: #23225f;
    transform: translateY(-2px);
    box-shadow: 0 4px 8px rgba(47, 46, 139, 0.3);
}

.export-button-top .btn-weflix svg {
    font-size: 1rem;
}

@media (max-width: 768px) {
    .export-button-top {
        width: 100%;
        justify-content: flex-end;
        margin-top: 0.5rem;
    }
    
    .export-button-top .btn-weflix {
        padding: 0.5rem 1rem;
    }
    
    .export-button-top .btn-weflix span {
        font-size: 0.875rem;
    }
}

.reports-container .btn-filter-container {
    display: flex;
    gap: 10px;
}
/* DARK */
.dashboard.dark .container.reports-container.weeducAdminReports .users-container .card {
    background-color: #575757 !important;
}
.dashboard.dark .container.reports-container.weeducAdminReports .weeduc-admin-reports .search-input {
    background-color: #575757;
    color: white;
    border: 1px solid #444;
}

.dashboard.dark .users-table-responsive {
    background-color: #000 !important;
}
.forceHide {
  display: none !important;
}
.noSearchTabs {
    position: absolute;
    top: 0;
    right: 0;
    z-index: 1000;
}
@media (max-width: 768px) {
    .noSearchTabs {
        position: relative !important;
    }
}
</style>